import {Head} from "@/layout/Head.tsx";

type PageHeaderProps = {
    title: string;
}

export function PageHeader(props: PageHeaderProps) {

    const {title} = props

    return (
        <header className="flex items-center w-full justify-between">
            <Head title={'ידע פון - ' + title}/>
            <div className="flex-grow">
                {/*<Breadcrumb dir="rtl">*/}
                {/*    <BreadcrumbList>*/}
                {/*        <BreadcrumbItem>*/}
                {/*            <BreadcrumbLink asChild>*/}
                {/*                <Link to="/extensions">*/}
                {/*                    שלוחות*/}
                {/*                </Link>*/}
                {/*            </BreadcrumbLink>*/}
                {/*        </BreadcrumbItem>*/}
                {/*        /!*<BreadcrumbSeparator>*!/*/}

                {/*        /!*</BreadcrumbSeparator>*!/*/}
                {/*        /!*<BreadcrumbItem>*!/*/}
                {/*        /!*    <BreadcrumbLink href="/components">Components</BreadcrumbLink>*!/*/}
                {/*        /!*</BreadcrumbItem>*!/*/}
                {/*    </BreadcrumbList>*/}
                {/*</Breadcrumb>*/}
                <div>
                    <h1 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
                        {title}
                    </h1>
                </div>
            </div>
            <div className="flex items-center gap-2">
                {/*<Button variant="ghost" className="cursor-pointer hover:bg-gray-200" size="icon">*/}
                {/*    <Squares2X2Icon className="!size-5 text-gray-400"/>*/}
                {/*</Button>*/}
            </div>
        </header>
    )
}